export interface StockProjectionBusinessMaster {
  id: string;
  tenant_id?: string | null;
  archived_at?: string | null;
}

export function activeBusinessIdsForTenant(
  businesses: readonly StockProjectionBusinessMaster[],
  tenantId: string | null,
): Set<string> {
  const ids = new Set<string>();
  for (const business of businesses) {
    if (business.archived_at) continue;
    if (business.tenant_id && business.tenant_id !== tenantId) continue;
    const id = business.id?.trim();
    if (id) ids.add(id);
  }
  return ids;
}

export function shouldIncludeLegacyUnscopedBusiness(input: {
  activeBusinessIds: ReadonlySet<string>;
  activeBusinessId: string | null;
  isLoading: boolean;
  isError: boolean;
}): boolean {
  if (input.isLoading || input.isError) return false;
  return input.activeBusinessId !== null
    && input.activeBusinessIds.size === 1
    && input.activeBusinessIds.has(input.activeBusinessId);
}
